import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const menuItems = [
    { label: 'Home', id: 'hero' },
    { label: 'O ATMOS', id: 'conceito' },
    { label: 'Localização', id: 'localizacao' },
    { label: 'Plantas', id: 'plantas' },
    { label: 'Disponibilidade', id: 'disponibilidade' },
    { label: 'Galeria', id: 'galeria' },
    { label: 'FAQ', id: 'faq' },
    { label: 'Contato', id: 'contato' },
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img
                src="https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/9d06b718332fff8e050249d6edbe5f33.png"
                alt="Levalo Soluções Imobiliárias"
                className="h-12 w-auto"
              />
            </Link>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center space-x-8">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    isScrolled ? 'text-gray-800 hover:text-primary' : 'text-white hover:text-gray-200'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>

            {/* CTA Button */}
            <a
              href="https://wa.me/5541988674555?text=Olá! Gostaria de saber mais sobre o ATMOS."
              target="_blank"
              rel="noopener noreferrer"
              className="hidden lg:flex items-center space-x-2 bg-[#25D366] text-white px-6 py-3 rounded-full font-medium text-sm hover:bg-[#20BA5A] transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              <span>Falar no WhatsApp</span>
            </a>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2 cursor-pointer"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${isScrolled ? 'text-gray-800' : 'text-white'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200">
            <div className="px-6 py-4 space-y-3">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="block w-full text-left text-gray-800 hover:text-primary font-medium py-2 cursor-pointer"
                >
                  {item.label}
                </button>
              ))}
              <a
                href="https://wa.me/5541988674555?text=Olá! Gostaria de saber mais sobre o ATMOS."
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center space-x-2 bg-[#25D366] text-white px-6 py-3 rounded-full font-medium text-sm mt-4 hover:bg-[#20BA5A] transition-all cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg"></i>
                <span>Falar no WhatsApp</span>
              </a>
            </div>
          </div>
        )}
      </nav>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/5541988674555?text=Olá! Gostaria de saber mais sobre o ATMOS."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 hover:bg-[#20BA5A] transition-all z-50 cursor-pointer"
        aria-label="Falar no WhatsApp"
      >
        <i className="ri-whatsapp-fill text-white text-3xl"></i>
      </a>
    </>
  );
}
